// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Завдання» (Tasks, ключ `task`, група `management`). */
export const tasksManifest: IModuleManifest = {
  key: 'task',
  group: 'management',
  slug: 'tasks',
  prefix: 'TSK',
  name: { en: 'Tasks', uk: 'Завдання' },
  entities: [
    { key: 'task', slug: 'task', name: { en: 'Tasks', uk: 'Завдання' }, main: true },
    { key: 'task_member', slug: 'task-member', name: { en: 'Task Members', uk: 'Учасники' }, main: false },
    { key: 'task_checklist_item', slug: 'task-checklist-item', name: { en: 'Task Checklist Items', uk: 'Пункти чек-листа' }, main: false },
    { key: 'task_time_entry', slug: 'task-time-entry', name: { en: 'Task Time Entries', uk: 'Записи часу' }, main: false },
    { key: 'task_dependency', slug: 'task-dependency', name: { en: 'Task Dependencies', uk: 'Залежності' }, main: false },
    { key: 'task_status', slug: 'task-status', name: { en: 'Task Statuses', uk: 'Статуси' }, main: false },
    { key: 'task_type', slug: 'task-type', name: { en: 'Task Types', uk: 'Типи завдань' }, main: false },
  ],
  loadState: () => import('./state/tasksSlice').then((m) => m.tasksSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
  loadViews: () => import('./views').then((m) => m.views),
};
